var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 14,
    viewBox: "0 0 30 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0H22.3478C26.2138 0 29.3478 3.13401 29.3478 7V7C29.3478 10.866 26.2138 14 22.3478 14H7C3.13401 14 0 10.866 0 7V7Z",
    fill: "#2DA4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4316 10L21.8534 4H22.9302L25.3478 10H24.0992L22.6663 6.23743L22.3897 5.44553H22.3604L22.1006 6.23324L20.6719 10H19.4316ZM20.5252 8.78492L20.8604 7.81704H23.8772L24.2249 8.78492H20.5252Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5347 10V4.51955H17.7163V10H16.5347ZM14.6953 5.07682V4H19.5556V5.07682H14.6953Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85938 10V4H13.8105V5.05587H11.0367V8.94413H13.9194V10H9.85938ZM10.6094 7.38547V6.40084H13.2658V7.38547H10.6094Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10V4H6.43855C7.01117 4 7.46229 4.14246 7.7919 4.42737C8.1243 4.7095 8.2905 5.06704 8.2905 5.5C8.2905 5.86871 8.20251 6.1648 8.02654 6.38827C7.85335 6.61173 7.63268 6.76955 7.36453 6.86173V6.89106C7.71927 6.96089 8.00978 7.1229 8.23603 7.37709C8.46229 7.63128 8.57542 7.95391 8.57542 8.34497C8.57542 8.81983 8.40642 9.21508 8.06844 9.53073C7.73324 9.84358 7.26676 10 6.66899 10H4ZM5.18156 9.03212H6.44274C6.71369 9.03212 6.93715 8.9595 7.11313 8.81425C7.28911 8.66899 7.37709 8.46927 7.37709 8.21508C7.37709 7.96648 7.28771 7.76117 7.10894 7.59916C6.93296 7.43436 6.69413 7.35196 6.39246 7.35196H4.91341V6.49721H6.22905C6.49721 6.49721 6.71369 6.43017 6.87849 6.29609C7.04609 6.16201 7.12989 5.96927 7.12989 5.71788C7.12989 5.46369 7.04469 5.27654 6.8743 5.15642C6.7067 5.03352 6.49162 4.97207 6.22905 4.97207H5.18156V9.03212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.0bbb4be05a962b440f79f4705f05298e.svg";
export { ForwardRef as ReactComponent };